import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useSpring, animated } from 'react-spring';


function AnimationLeftToRight({children}) {
  const [state, toggle] = useState(true)
  const styles = useSpring({
    from: { x: '-100%' },
    config: { duration: 1500 },
    loop: {
      x: '0%',
    },
  })
  return (
    <div onClick={() => toggle(!state)}>
      <animated.div
        style={{
            width: '100%',
            height: '100%',
            ...styles,
          }}>
        {children}
      </animated.div>
    </div>
  )
}

export default AnimationLeftToRight